export const AUTHORIZATION_HIGHLIGHT_STORAGE_KEY = 'authorization-highlight-state';
export const DMEPOS_PRODUCT_TYPE = 'dmepos';
